var _a, _b, _c, _d;
import { ClassicGameId } from '../enums/ClassicGameId';
import { RedBlueBettingOptionClasses } from '../enums/RedBlueBettingOptionClasses';
import { WheelOptionsClasses } from '../enums/WheelOptionsClasses';
import { RouletteOptionsClasses } from '../enums/RouletteOptionsClasses';
var RED_BLUE_OPPOSITE_OPTIONS = (_a = {},
    _a[RedBlueBettingOptionClasses.RED] = RedBlueBettingOptionClasses.BLUE,
    _a[RedBlueBettingOptionClasses.BLUE] = RedBlueBettingOptionClasses.RED,
    _a);
var WHEEL_OPPOSITE_OPTIONS = (_b = {},
    _b[WheelOptionsClasses.BLACK] = [WheelOptionsClasses.RED, WheelOptionsClasses.GREY],
    _b[WheelOptionsClasses.GREY] = [WheelOptionsClasses.BLACK, WheelOptionsClasses.RED],
    _b[WheelOptionsClasses.RED] = [WheelOptionsClasses.BLACK, WheelOptionsClasses.GREY],
    _b[WheelOptionsClasses.FROM_1_TO_6] = [
        WheelOptionsClasses.FROM_7_TO_12,
        WheelOptionsClasses.FROM_13_TO_18,
    ],
    _b[WheelOptionsClasses.FROM_7_TO_12] = [
        WheelOptionsClasses.FROM_1_TO_6,
        WheelOptionsClasses.FROM_13_TO_18,
    ],
    _b[WheelOptionsClasses.FROM_13_TO_18] = [
        WheelOptionsClasses.FROM_1_TO_6,
        WheelOptionsClasses.FROM_7_TO_12,
    ],
    _b);
export var ROULETTE_OPPOSITE_OPTIONS = (_c = {},
    _c[RouletteOptionsClasses.RED] = RouletteOptionsClasses.BLACK,
    _c[RouletteOptionsClasses.BLACK] = RouletteOptionsClasses.RED,
    _c[RouletteOptionsClasses.ODD] = RouletteOptionsClasses.EVEN,
    _c[RouletteOptionsClasses.EVEN] = RouletteOptionsClasses.ODD,
    _c[RouletteOptionsClasses.LOW] = RouletteOptionsClasses.HIGH,
    _c[RouletteOptionsClasses.HIGH] = RouletteOptionsClasses.LOW,
    _c);
export var GAME_OPPOSITE_OPTIONS = (_d = {},
    _d[ClassicGameId.DICE_DUEL] = RED_BLUE_OPPOSITE_OPTIONS,
    _d[ClassicGameId.RNG_FOOTBALL_GRID] = RED_BLUE_OPPOSITE_OPTIONS,
    _d[ClassicGameId.WHEEL] = WHEEL_OPPOSITE_OPTIONS,
    _d[ClassicGameId.RNG_WHEEL] = WHEEL_OPPOSITE_OPTIONS,
    _d);
